var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrivacypolicy({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6666 9.99984V4.79067C16.6667 4.72489 16.6538 4.65975 16.6286 4.59897C16.6034 4.5382 16.5665 4.48299 16.52 4.4365L13.8966 1.81317C13.803 1.71938 13.6759 1.66662 13.5433 1.6665H3.83331C3.7007 1.6665 3.57353 1.71918 3.47976 1.81295C3.38599 1.90672 3.33331 2.0339 3.33331 2.1665V17.8332C3.33331 17.9658 3.38599 18.093 3.47976 18.1867C3.57353 18.2805 3.7007 18.3332 3.83331 18.3332H10.8333M6.66665 8.33317H13.3333M6.66665 4.99984H9.99998M6.66665 11.6665H9.16665",
    stroke: "#2B2B2B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 1.6665V4.49984C13.3333 4.63245 13.386 4.75962 13.4798 4.85339C13.5735 4.94716 13.7007 4.99984 13.8333 4.99984H16.6666M16.66 12.604L18.79 13.1448C19.0116 13.2015 19.1675 13.4032 19.1608 13.6315C19.0175 18.4298 16.25 19.1665 16.25 19.1665C16.25 19.1665 13.4825 18.4298 13.3391 13.6315C13.3369 13.5204 13.3723 13.4118 13.4396 13.3235C13.507 13.2351 13.6023 13.1721 13.71 13.1448L15.84 12.604C16.1091 12.5357 16.3908 12.5357 16.66 12.604Z",
    stroke: "#2B2B2B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivacypolicy);
export default __webpack_public_path__ + "static/media/privacypolicy.b9dc2183c123a8fdfc60ade8c0663b8e.svg";
export { ForwardRef as ReactComponent };